export const NATIVE_LANGUAGE_CODES = ['en', 'ua', 'ru', 'pl', 'be'] as const;

export type NativeLanguageCode = (typeof NATIVE_LANGUAGE_CODES)[number];

export type MentorCategorySummary = {
  id: number;
  title: string;
};

export type MentorPublicProfile = {
  displayName: string;
  headline: string | null;
  description: string | null;
  goals: string | null;
  introVideoUrl: string | null;
  avatarUrl: string | null;
  timezone: string | null;
  nativeLanguages: string[];
  experienceYears: number | null;
  isActive: boolean;
  updatedAt?: string;
};

export type MentorMe = {
  id: number;
  userId: number;
  sku: string;
  slug: string;
  publicPath: string;
  status: string;
  isActive: boolean;
  isTop: boolean;
  profile: MentorPublicProfile | null;
  categoryIds: number[];
  createdAt: string;
  updatedAt: string;
};

export type MentorListItem = {
  id: number;
  userId: number;
  sku: string;
  slug: string;
  publicPath: string;
  status: string;
  isActive: boolean;
  isTop: boolean;
  profile: MentorPublicProfile | null;
  categories: MentorCategorySummary[];
  categoryIds: number[];
};

export type MentorCatalogCategory = {
  id: number;
  name: string;
  slug: string;
  mentorCount: number;
};

export type LessonPrice = {
  amount: number;
  currency: string;
  durationMinutes: number;
};

export type AvailableSlot = {
  startsAt: string;
  endsAt: string;
};

export type MentorCatalogItem = {
  id: number;
  slug: string;
  publicPath: string;
  displayName: string;
  headline: string | null;
  avatarUrl: string | null;
  categories: Array<{ id: number; name: string }>;
  price: LessonPrice | null;
};

export type MentorCatalogPage = {
  categories: MentorCatalogCategory[];
  mentors: {
    items: MentorCatalogItem[];
    total: number;
    nextCursor: string | null;
  };
};

export type MentorListResponse = {
  list: MentorListItem[];
  page: number;
  limit: number;
  total: number;
  totalPages: number;
};

export type UpdateMentorMeRequest = {
  slug?: string;
  profile?: {
    displayName?: string;
    headline?: string | null;
    description?: string | null;
    goals?: string | null;
    introVideoUrl?: string | null;
    avatarUrl?: string | null;
    timezone?: string | null;
    nativeLanguages?: string[];
    experienceYears?: number | null;
  };
  categoryIds?: number[];
};

export type MentorProfileFormValues = {
  displayName: string;
  headline: string;
  description: string;
  goals: string;
  introVideoUrl: string;
  avatarUrl: string;
  timezone: string;
  nativeLanguages: string[];
  experienceYears: string;
  categoryIds: string[];
};
